import {Injectable, InjectionToken, Inject} from '@angular/core';
import {PAY_EDITION} from "@root/config";
import {Subject} from "rxjs/Subject";
import {Observable} from "rxjs/Observable";
import { Platform } from '@angular/cdk/platform';
import {BehaviorSubject} from "rxjs";

interface User {
  [key: string]: any;
  name?: string;
  account?: string;
  avatar?: string;
}

interface App {
  version?: any;
  international?: boolean;
  language?: 0 | 1 | 2 | 3; // 0-zh 1-tw 2-en 3-jp
}

interface Member {
  [key: string]: any;
  edition: 0 | 1 | 2 | 3; // 0-free 1-trial 2-pro 3-ent
  status?: 1 | 2 | 3 | 4; // 1-normal 2-expired 3-exceed_in 4-exceed_out
}

interface AppNotify {
  type: 'user' | 'app' | 'member';
  value?: any;
}

@Injectable({
  providedIn: 'root'
})
export class AppService {

  private notify$ = new BehaviorSubject<AppNotify>(null);

  private _user: User = null;
  private _app: App = null;
  private _member: Member = null;

  get notify(): Observable<AppNotify> {
    return this.notify$.asObservable();
  }

  constructor(
    private platform: Platform
  ) {
  }

  getData(key: string): any {
    if (!this.platform.isBrowser) {
      return null;
    }
    return JSON.parse(localStorage.getItem(key) || 'null') || null;
  }

  setData(key: string, value: any): void {
    if (!this.platform.isBrowser) {
      return;
    }
    localStorage.setItem(key, JSON.stringify(value));
  }

  get user(): User {
    if (!this._user) {
      this._user = { ...this.getData('$$hostex_app_user') };
      this.setData('$$hostex_app_user', this._user);
    }
    return this._user as User;
  }

  get member(): Member {
    if (!this._member) {
      this._member = { ...this.getData('$$hostex_app_member') };
      this.setData('$$hostex_app_member', this._member);
    }
    return this._member as Member;
  }

  get app(): App {
    if (!this._app) {
      this._app = { ...this.getData('$$hostex_app_app') };
      this.setData('$$hostex_app_app', this._app);
    }
    return this._app as App;
  }

  setUser(value: User): void {
    this._user = value;
    this.setData('$$hostex_app_user', value);
    this.notify$.next({ type: 'user', value });
  }


  setMember(value: Member): void {
    this._member = value;
    this.setData('$$hostex_app_member', value);
    this.notify$.next({ type: 'member', value });
  }

  setApp(value: App): void {
    this._app = value;
    this.setData('$$hostex_app_app', value);
    this.notify$.next({ type: 'app', value });
  }

  updateUser(value: User): void {
    const user = { ...this._user, ...value };
    this.setUser(user);
  }
}
